import React from 'react';

class Header extends React.Component {
  render() {
    // eslint-disable-next-line
    return (
      <div className="header-container">
          <div className="header">
              <a className="logo-link" href="https://www.michigandaily.com/" target="_blank" >
              <img className="tmd-logo" src={`${process.env.PUBLIC_URL}/images/silence/tmd-logo.png`} alt="tmd-logo"/>
              </a>
          </div>
  
        <div className="headline">Buying Silence</div>
        <div className="header-image" />
        <div className="deck">
          The University of Michigan spent over $1.26 million in confidential agreements, preventing employees from speaking out.
        </div>
        <div className="byline">
          <span className="author-name">Samantha Small, Sammy Sussman, Zayna Syed / </span>
          <span className="author-title">Daily Staff Reporters</span>
        </div>
      </div>
      );
  }
}

export default Header;